/* eslint-disable react/prop-types */
import React from 'react'
import cls from 'classnames'

import AdvertisementLabel from 'components/advertisement-label'
import FooterLinks from 'components/footer-links'
import { PSL } from 'common/const/marketplace'

import { SUPPORTED_PARTNERS, VERTICAL_NAME_MAP } from './const'
import LenderCard from './LenderCard'
import styles from './FeaturedLenderBanner.module.scss'
import useFetchLenderStrapiData from './useFetchLenderStrapiData'

const FeaturedLenderBanner = ({ lenders, vertical, theme }) => {
  const [lender1, lender2] = lenders
  const strapiLenders = useFetchLenderStrapiData({
    vertical,
    partner: theme,
    lenders,
  })

  const TitleTag = theme === 'wsj' && vertical === PSL ? 'p' : 'h1'

  return SUPPORTED_PARTNERS.includes(theme) ? (
    <div className={cls(styles.wrapper, [styles[theme]])}>
      <div className={styles.titleWrap}>
        <TitleTag className="featured-lender-banner-title">
          Top {VERTICAL_NAME_MAP[vertical]} Lenders
        </TitleTag>
        <AdvertisementLabel />
      </div>
      <div className={styles.lenderCards}>
        <LenderCard
          position={1}
          lender={lender1.data}
          lenderSlug={lender1.slug}
          lenderName={lender1.name}
          rating={strapiLenders.find((l) => l.slug === lender1.slug)?.buySideContent?.rating}
          best
        />
        <LenderCard
          position={2}
          lender={lender2.data}
          lenderSlug={lender2.slug}
          lenderName={lender2.name}
          rating={strapiLenders.find((l) => l.slug === lender2.slug)?.buySideContent?.rating}
        />
      </div>
      <FooterLinks containerClassName="mt-16" />
    </div>
  ) : (
    'Widget is not configured for this partner'
  )
}

export default FeaturedLenderBanner
